import { ConfirmPositiveModal } from '@/shared/components/confirmation'
import { confirmationCautionButtonSx } from '@/shared/components/confirmation/confirmationModalStyles'

interface Props {
  open: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  confirming: boolean
}

/** BFP-616 — pause instrument confirmation. */
export function PauseInstrumentDialog({
  open,
  onClose,
  onConfirm,
  confirming,
}: Readonly<Props>) {
  return (
    <ConfirmPositiveModal
      open={open}
      iconVariant="pause"
      headline="Pause Instrument"
      bodyLines={[
        'Pausing will stop response collection immediately. The instrument budget will be returned to your account. You can reactivate this instrument at any time.',
      ]}
      dismissLabel="Cancel"
      confirmLabel="Confirm Pause"
      confirmButtonSx={confirmationCautionButtonSx}
      confirmDisabled={confirming}
      confirmPending={confirming}
      onDismiss={onClose}
      onConfirm={() => void Promise.resolve(onConfirm())}
      allowDismiss={!confirming}
      dialogTestId="instrument-dashboard-pause-dialog"
      dismissTestId="instrument-dashboard-pause-cancel"
      confirmTestId="instrument-dashboard-pause-confirm"
    />
  )
}
